import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaDeduccionesDetallado', NominasNominaDeduccionesDetallado)

function NominasNominaDeduccionesDetallado($q, $state, NominasNomina, NominasNominaEmpleados, NominasNominaSuministro, NominasNominaConceptos, NominasNominaPermisos, NominasNominaRecibos, $interpolate, $filter) {
  this.get = get

  function get(idEmpresa, idNomina) {
    return $q.all({
      nomina: NominasNomina.get(idEmpresa, idNomina),
      nominaEmpleados: NominasNominaEmpleados.get(idEmpresa, idNomina),
      nominaSuministro: NominasNominaSuministro.get(idEmpresa, idNomina),
      nominaConceptos: NominasNominaConceptos.get(idEmpresa, idNomina),
      permisos: NominasNominaPermisos.get(idEmpresa, idNomina),
    }).then(function ($resolve) {
      return generarGrid({
        nomina: $resolve.nomina,
        nominaConceptos: $resolve.nominaConceptos,
        nominaDeducciones: $resolve.nominaSuministro.map(function (suministro, index) {
          return angular.merge(suministro, $resolve.nominaEmpleados[index])
        }),
        permisos: $resolve.permisos,
      })
    })
  }

  function generarGrid($resolve) {
    let gridData = {
      importeEditado: false,
      pinnedColumnCount: 6,
      enableColResize: true,
      rowSelection: 'single',
      columnDefs: columnDefs(),
      rowData: $filter('orderBy')($resolve.nominaDeducciones, ['Empresa', 'Departamento', 'Empleado']),
      icons: {
        groupExpanded: '<i class="fa fa-fw fa-chevron-down"></i>',
        groupContracted: '<i class="fa fa-fw fa-chevron-right"></i>',
        headerGroupOpened: '<i class="fa fa-fw fa-chevron-left"></i>',
        headerGroupClosed: '<i class="fa fa-fw fa-chevron-right"></i>',
      },
      groupUseEntireRow: false,
      groupKeys: ['Empresa', 'Departamento'],
      groupHeaders: true,
      groupDefaultExpanded: true,
      cellValueChanged: cellValueChanged,
      groupAggFunction: groupAggFunction,
      groupColumnDef: {
        headerName: 'Empresa > Depto. > Empleado',
        field: 'Empleado',
        width: 250,
        minWidth: 200,
        cellRenderer: {
          renderer: 'group',
          padding: 10,
          innerRenderer: empleadoRenderer,
        },
      },
    }

    return gridData

    function columnDefs() {
      return ([
        {
          field: 'ID_Empleado',
          hide: true,
        }, {
          field: 'Empleado',
          hide: true,
        }, {
          field: 'Empresa',
          hide: true,
        }, {
          field: 'Departamento',
          hide: true,
        }, {
          headerName: 'Subtotal',
          field: 'Subtotal',
          width: 90,
          minWidth: 80,
          editable: function () {
            return $resolve.nomina.Status !== 'C'
          },
          cellRenderer: suministroRenderer,
          newValueHandler: suministroEditar,
          headerGroup: 'Neto',
          headerGroupShow: 'open',
        }, {
          headerName: 'Com. %',
          field: 'Comision_Porcentaje',
          width: 60,
          minWidth: 60,
          cellRenderer: percentRenderer,
          headerGroup: 'Neto',
          headerGroupShow: 'open',
        }, {
          headerName: 'Com. importe',
          field: 'Comision_Importe',
          width: 90,
          minWidth: 80,
          cellRenderer: currencyRenderer,
          headerGroup: 'Neto',
          headerGroupShow: 'open',
        }, {
          headerName: 'Total',
          field: 'Total',
          width: 90,
          minWidth: 80,
          cellRenderer: currencyRenderer,
          cellStyle: {'font-weight': 'bold'},
          headerGroup: 'Neto',
        }, {
          headerName: 'Saldo',
          field: 'Saldo',
          width: 90,
          minWidth: 80,
          cellRenderer: currencyRenderer,
        },
      ]).concat($resolve.nominaConceptos.map(function (concepto) {
        return {
          headerName: (concepto.Activo ? '* ' : '') + concepto.Concepto,
          field: concepto.ID_Concepto,
          width: 90,
          minWidth: 80,
          cellRenderer: currencyRenderer,
          headerTooltip: concepto.ID_Concepto + ' - ' + concepto.Concepto + (
            concepto.Activo ? '(Calculado)' : '(No calculado)'
          ),
          headerGroup: 'Deducciones',
          editable: function () {
            return ($resolve.nomina.Status !== 'C' && $resolve.permisos['deducciones.editar']) && !gridData.importeEditado
          },
          valueGetter: conceptoValue,
          newValueHandler: conceptoEditar,
          cellStyle: conceptoStyle,
        }
      })).concat([
        {
          headerName: 'Deducciones',
          headerGroup: 'Totales',
          field: 'Total_Deducciones',
          width: 90,
          minWidth: 80,
          cellRenderer: currencyRenderer,
          cellStyle: currencyStyle,
          valueGetter: totalDeduccionesValue,
        }, {
          headerName: 'A pagar',
          headerGroup: 'Totales',
          field: 'Total_Pagar',
          width: 90,
          minWidth: 80,
          cellRenderer: currencyRenderer,
          cellStyle: totalPagarStyle,
          valueGetter: totalPagarValue,
        },
      ])
    }

    function cellValueChanged(params) {
      params.api.refreshView()
      params.api.recomputeAggregates()
    }

    function currencyRenderer(params) {
      let folio = params.data.Deducciones && params.data.Deducciones[params.colDef.field] && params.data.Deducciones[params.colDef.field].folio,
        importe = params.value,
        link = folio
          ? $state.href('empleado.servicios.servicio', {
            idEmpresa: params.data.ID_Empresa,
            idEmpleado: params.data.ID_Empleado,
            idMoneda: $resolve.nomina.ID_Moneda,
            folio: folio,
          })
          : null,
        template = folio
          ? '<div align="right"><a class="link text-primary" target="_blank" href="{{link}}"><b><span float="left">$</span> {{importe | currency: ""}}</b></a></div>'
          : '<div align="right"><span float="left">$</span> {{importe | currency: ""}}</div>'

      return $interpolate(template)({
        importe: importe,
        link: link,
      })
    }

    function currencyStyle(params) {
      let style = {}
      if (params.value < 0)
        style['color'] = 'red'

      if (params.value === 0)
        style['color'] = 'rgba(0, 0, 0, 0.2)'

      if (gridData.importeEditado)
        style['opacity'] = '0.3'
      return style
    }

    function conceptoEditar(params) {
      let value = params.newValue === '' ? null : Number(params.newValue),
        codigo = params.colDef.field,
        deduccion = params.data.Deducciones[codigo]

      // Si el nuevo no es null o es un número < 0, regresar error
      if (isNaN(value) || value < 0)
        return window.alert('Error: El importe debe ser un número mayor o igual a cero')

      // Si el nuevo valor es igual al anterior, regresar
      if ((angular.isNumber(deduccion.editado) ? deduccion.editado : deduccion.calculado) === value)
        return

      // Si el valor es igual a null
      if (value === null) {
        // Eliminar edición
        delete deduccion.editado
      } else {
        // Si no, editar
        deduccion.editado = value
      }

      return NominasNominaSuministro.editar($resolve.nomina.ID_Nomina, params.data.ID_Empresa, params.data.ID_Empleado, codigo, value, $resolve.nomina.Fecha_Pago.toYMD())
        .catch(function () {
          alert('Hubo un error al intentar editar el importe.')
        })
    }

    function conceptoStyle(params) {
      let style = {}
      if (params.value === 0)
        style['color'] = 'rgba(0, 0, 0, 0.2)'

      if (angular.isNumber(params.data.Deducciones[params.colDef.field].editado))
        style['color'] = 'darkorange'

      if (params.value < 0)
        style['color'] = 'red'

      if (gridData.importeEditado)
        style['opacity'] = '0.3'

      return style
    }

    function conceptoValue(params) {
      let codigo = params.colDef.field,
        deduccion = params.data.Deducciones[codigo]

      return angular.isNumber(deduccion.editado)
        ? deduccion.editado
        : deduccion.calculado
    }

    function empleadoRenderer(params) {
      if (params.node.group) {
        return (params.node.field === 'Departamento'
          ? 'Depto. '
          : '')
          + params.node.key
      } else {
        let ID_Nomina = $resolve.nomina.ID_Nomina,
          ID_Empresa = params.data.ID_Empresa,
          ID_Empleado = params.data.ID_Empleado,
          url = NominasNominaRecibos.generarUrl(ID_Empresa, ID_Empleado, ID_Nomina),
          link = $state.href('empleado.servicios.buscar', {
            idEmpresa: params.data.ID_Empresa,
            idEmpleado: params.data.ID_Empleado,
            idMoneda: $resolve.nomina.ID_Moneda,
          }),
          template = '<a class="link tag" href="{{::link}}" style="text-align:center;width:50px;line-height:1.5;margin-right:4px" target="_blank" title="Informaci&oacute;n del Kardex"><code>{{idEmpleado}}</code></a> {{empleado}}'
        // + '<a href="{{::url}}" float="right" target="_blank" class="link" title="Recibo de n&oacute;mina"><i class="fa fa-file-text-o"></i></a>';
        return $interpolate(template)({link: link, url: url, idEmpleado: params.data.ID_Empleado, empleado: params.value})
      }
    }

    function groupAggFunction(nodes) {
      let sums = {Deducciones: {}}
      nodes.forEach(function (node) {
        ['Subtotal', 'Saldo', 'Total', 'Comision_Importe', 'Total_Deducciones', 'Total_Pagar'].forEach(function (field) {
          sums[field] = (sums[field] || 0) + node.data[field]
        })

        $resolve.nominaConceptos.forEach(function (concepto) {
          let deduccion = node.data.Deducciones[concepto.ID_Concepto],
            importe = angular.isNumber(deduccion.editado) ? deduccion.editado : deduccion.calculado,
            acumulado = sums.Deducciones[concepto.ID_Concepto] ? sums.Deducciones[concepto.ID_Concepto].calculado : 0

          sums.Deducciones[concepto.ID_Concepto] = {
            calculado: acumulado + importe,
          }
        })
      })

      return sums
    }

    function percentRenderer(params) {
      return angular.isNumber(params.value)
        ? '<div style="text-align:center">' + (params.value * 100).toFixed(2) + ' %</div>'
        : ''
    }

    function suministroEditar(params) {
      let value = Number(params.newValue)

      if (value === params.oldValue)
        return

      if (value >= 0) {
        params.data['Subtotal'] = undefined
        NominasNominaEmpleados.editar($resolve.nomina.ID_Nomina, params.data.ID_Empresa, params.data.ID_Empleado, value)
          .then(function (data) {
            params.data.Subtotal = value
            params.data.Comision_Importe = data.Comision_Importe
            params.data.Total = value - data.Comision_Importe
            gridData.importeEditado = true
            cellValueChanged(params)
          })
          .catch(function () {
            alert('Hubo un error al intentar editar el importe.')
          })
      } else {
        alert('Error: El importe debe ser un número mayor o igual a cero')
      }
    }

    function suministroRenderer(params) {
      if (params.value === undefined) {
        return '<small><i>Actualizando...</i></small>'
      } else {
        return currencyRenderer(params)
      }
    }

    function totalDeduccionesValue(params) {
      let total = 0
      angular.forEach($resolve.nominaConceptos, function (concepto) {
        let deduccion = params.data.Deducciones[concepto.ID_Concepto]
        total += angular.isNumber(deduccion.editado) ? deduccion.editado : deduccion.calculado
      })
      return params.data['Total_Deducciones'] = total
    }

    function totalPagarStyle(params) {
      return angular.merge({'font-weight': 'bold'}, currencyStyle(params))
    }

    function totalPagarValue(params) {
      return params.data['Total_Pagar'] = round(round(params.data['Total']) - round(params.data['Total_Deducciones']))
    }

    function round(val) {
      return Math.round(val * 100) / 100
    }
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Deducciones/Detallado.js